import { useContext } from 'react';
import { GlobalConfigContext, GlobalConfigContextType } from '../contexts/GlobalConfigContext';

export const useGlobalConfig = (): GlobalConfigContextType => {
  const context = useContext(GlobalConfigContext);
  if (context === undefined) {
    throw new Error('useGlobalConfig must be used within a GlobalConfigProvider');
  }
  return context;
}; 